module.exports = __webpack_public_path__ + "static/media/zalo.9087cf4a.svg";